import { Modal, ModalBody, ModalHeader, CardBody, CardTitle } from 'reactstrap'
import { IconTrash } from '@tabler/icons-react'
import { IconX } from '@tabler/icons-react'
//@ts-ignore
import { Button } from 'dsm-react-lib'

interface DeleteChatModalProps {
  isOpen: boolean
  toggle: () => void
  onDelete: (chatId: string) => void
  chatTitle: string
  isDeletingChat: boolean
}

const DeleteChatModal: React.FC<DeleteChatModalProps> = ({
  isOpen,
  toggle,
  onDelete,
  chatTitle,
  isDeletingChat
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader
        className={`!justify-between !border-0 !flex !items-center chat-primary theme-bg`}
        toggle={toggle}
        close={
          <IconX
            size={24}
            onClick={toggle}
            className="theme-text-subheading transition-colors duration-300 ease-in-out hover:text-white cursor-pointer"
            data-testid="close-button"
          />
        }>
        <div className="flex items-center">
          <IconTrash className="me-1" color="white" />
          <span className="text-white font-bold">Delete Chat?</span>
        </div>
      </ModalHeader>
      <ModalBody className="flex-grow-1">
        <div className="text-center border-0">
          <CardBody className="px-0 py-1">
            <CardTitle className="font-normal">
              Are you sure you want to delete <b>{chatTitle}</b>? This action cannot be undone.
            </CardTitle>
          </CardBody>
        </div>
        <div className={`flex justify-end gap-1 my-1 chat-primary`}>
          <Button
            label="Cancel"
            variant="outline"
            color="neutral"
            className="dsm-btn-neutral"
            onClick={toggle}
          />
          <Button
            label={isDeletingChat ? 'Deleting...' : 'Confirm'}
            color="danger"
            disabled={isDeletingChat}
            onClick={onDelete}
          />
        </div>
      </ModalBody>
    </Modal>
  )
}

export default DeleteChatModal
